import { useCallback, useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    ThemeProvider
} from "@aws-amplify/ui-react";

import { theme } from "../theme";
import {
    FaceLivenessDetector
} from "@aws-amplify/ui-react-liveness";

import {
    startLiveness,
    processVerification
} from "../services/VerificationService";
export default function VerifyPage() {

    const { token } = useParams();

    const navigate = useNavigate();

    const initializationStarted =
        useRef(false);

    const processingStarted =
        useRef(false);

    const [sessionId, setSessionId] =
        useState(null);

    const [loading, setLoading] =
        useState(true);

    const initialize = useCallback(async () => {

        try {

            const response =
                await startLiveness(token);

            setSessionId(
                response.data.sessionId
            );

        }
        catch (error) {

            console.error(error);

            navigate("/failed");
        }
        finally {

            setLoading(false);
        }
    }, [navigate, token]);

    useEffect(() => {

        if (initializationStarted.current) {
            return;
        }

        initializationStarted.current = true;

        initialize();

    }, [initialize]);

    const handleComplete = async () => {

        if (processingStarted.current) {
            return;
        }

        processingStarted.current = true;

        try {

            const response =
                await processVerification(token);

            if (response.data.verified) {
                navigate("/success");
            }
            else {
                navigate("/failed");
            }
        }
        catch (error) {

            console.error(error);

            navigate("/failed");
        }
    };

    if (loading) {

        return (
            <main className="verify-shell">
                <div className="verify-state">
                    Preparing secure verification...
                </div>
            </main>
        );
    }

    if (!sessionId) {

        return (
            <main className="verify-shell">
                <div className="verify-state">
                    No verification session found.
                </div>
            </main>
        );
    }

    return (
        <main className="verify-shell">
            <section className="verify-panel">
                <div className="verify-header">
                    <span className="verify-badge">
                        Secure check
                    </span>

                    <h1>
                        ESGO Identity Verification
                    </h1>

                    <p>
                        Center your face and follow the on-screen prompts.
                    </p>
                </div>

                <div className="liveness-frame">

                    <FaceLivenessDetector
                        sessionId={sessionId}
                        region="us-east-1"
                        onAnalysisComplete={() => {
                            console.log("ANALYSIS COMPLETE");
                            handleComplete();
                        }}
                        onError={(error) => {
                            console.log("LIVENESS ERROR");
                            console.error(error);
                        }}
                    />

                </div>
            </section>
        </main>
    );
}
